<section class="main-section">
  <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">Invoice Settings</li>
  </ol>
</nav>
  <form>

  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <h2 class="mb-4">Invoice Types</h2>
        <div class="row">
          <div class="col-md-6">
            <input type="text" id="quantityTpe" [(ngModel)]="invoiceType" class="form-control"
                   (blur)="selectInvoiceType()" [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}" required
            placeholder="Define a new Invoice Type">
            <div  class="invalid-feedback d-block shift-invalid-login" id="statusText2" [hidden]="!statusText2">{{statusText2}}</div>
          </div>
          <div class="col-md-6">
                    <a (click)="createInvoiceType()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                        <defs><style>.ab{fill:#ee7125;}</style></defs>
                        <path class="ab" d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z" transform="translate(-3.375 -3.375)"/>
                      </svg>
                    </a>
          </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-12">
              <table class="table table-stripe">
                <thead>
                <tr>
                  <th class="w-25 p-l-0">Invoice Types</th>
                  <th class="w-25">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor = "let d of invoices">
                <td class="p-l-0">{{d.config}}</td>
                <td>
                  <a data-toggle="modal" data-target="#deleteEntryModal" (click)="selectedDeleteProduct(d)">
                    <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                      <defs><style>.a{fill:#848484;}</style></defs>
                      <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                    </svg>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="mb-4">Configure Invoice Sub Types</h2>
        <div class="row">
          <div class="col-md-6">
            <label class="mb-1 control-label">Invoice Type</label>
            <div class="form-group select-form-group">
          <ng-select id="product" [(ngModel)]="invoice" (click)="itemCode(invoice.config) "
                      [ngModelOptions]="{standalone: true}" required
                     [items]="invoices"
                     bindLabel="config"
                     [searchWhileComposing]="true"
                     placeholder="Select an Invoice Type">
          </ng-select>
        </div>
          </div>
        </div>
          <div class="row">
            <div class="col-md-6">
              <input type="text" id="invoiceItem" [(ngModel)]="invoiceItem" class="form-control"
                     (blur)="selectInvoiceItem()" [ngClass]="{'is-invalid':statusText1}" [ngModelOptions]="{standalone: true}" required
              placeholder="Define a new Sub type">
              <div  class="invalid-feedback d-block shift-invalid-login" id="statusText1" [hidden]="!statusText1">{{statusText1}}</div>
            </div>
            <div class="col-md-6">
              <a (click)="createItemCode()">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                  <defs><style>.ab{fill:#ee7125;}</style></defs>
                  <path class="ab" d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z" transform="translate(-3.375 -3.375)"/>
                </svg>
              </a>
            </div>
          </div>
      </div>
    </div>
    </div>
    <div class="row">
        <div class="col-md-12">
          <div class="inner-box">
          <table class="table table-stripe">
            <thead>
            <tr>
              <th class="w-25 p-l-0">Sub Type</th>
              <th class="w-25">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor = "let c of itemCodes">
              <td class="p-l-0">{{c.config}}</td>
              <td>
                <a data-toggle="modal" data-target="#deleteEntryModal" (click)="selectedDeleteItem(c)">
                  <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                    <defs><style>.a{fill:#848484;}</style></defs>
                    <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="container">
  <div class="modal fade" id="deleteEntryModal" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" id="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" id="no" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" id="yes" (click)="deleteReturnProduct()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
